import { BaseService } from "core/services";
import { TrackingCaseRouteService } from "application/tracking-case/services";

class TrackingCaseService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new TrackingCaseRouteService());
	}

	copy(resource) {
        const url = this.routeService.copy(resource);
        return this.apiClient.post(url);
    }
}

export default TrackingCaseService;